import React from 'react';
import { WbButton } from '@digital-engineering-experiences/wb-webcomponents';
import { authenticateUser } from '../utils/loginfunctions';
import { useNavigate } from 'react-router-dom';


export default function LoginComponent() {
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const data = {
            username: (e.target as any).username.value,
            password: (e.target as any).password.value
        };

        try {
            const result = await authenticateUser(data.username,data.password);
            navigate('/map');
        } catch (error) {
            const errorDetail = JSON.parse(error?.request?.responseText)?.detail;
            alert('There was a problem with the authentication operation: '+ errorDetail);
        }
    };

    return (
        <div className="loginpage">
            <form method="post" onSubmit={(e) => handleSubmit(e)}>
                <h1>Login</h1>
                <div className='inputgroup'>
                    <label htmlFor="username">Username:</label>
                    <input type="text" id="username" name="username" required />
                </div>
                <div className='inputgroup'>
                    <label htmlFor="password">Password:</label>
                    <input type="password" id="password" name="password" required />
                </div>
                <WbButton label="login" type="submit"></WbButton>
            </form>
        </div>
    );

}